<div #container class="container is-relative is-flex">
  <ng-content />
</div>
